export const mutations = {
  setNoticeList (state, noticeList) {
    state.noticeList = noticeList
    state.isLoaded = true
  }
}
